import React from 'react';
import { MuiGrid, MuiTypography, MuiPopover, muiWithStyles } from '../../ui/MaterialUIComponents';
import TimeTableBlock from './TimeTableBlock'

const useStyles = theme => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(1),
  },
});

class EventComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      anchorEl: null,
      open: false
    }
  }

  handlePopoverOpen = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
      open: event.currentTarget
    })
  };

  componentDidMount() {
      let anElement =  Array.from(document.querySelectorAll('span'))
    .find(el => el.textContent.includes('Period1'));

    if(anElement){
      anElement.scrollIntoView(true);
    }
  }
  handlePopoverClose = () => {
    this.setState({
      anchorEl: null,
      open: null
    })
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        {this.props.viewTimeTable ?
          //for time table display
          <TimeTableBlock {...this.props} />
          :
          this.props.blocket.isBreakLessThan15Min === true ?
            <MuiGrid
              elevation={3}
              style={{
                zIndex: 100,
                position: 'relative',
                width: '97%',
                cursor: 'pointer',
                borderRadius: '3px',
                background: this.props.blocket.style,
                height: this.props.cellHeight * this.props.blocket.totalBlocks - 1 + 'px'
              }}
              onClick={() => this.props.onEditOfPeriod(this.props.blocket.period, this.props.index, this.props.day)}
              onMouseOver={(event) => this.handlePopoverOpen(event)}
              onMouseLeave={this.handlePopoverClose}
            >
              <MuiPopover
                open={this.state.open}
                disableRestoreFocus
                anchorEl={this.state.anchorEl}
                className={classes.popover}
                classes={{
                  paper: classes.paper,
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <MuiTypography>
                  {this.props.blocket.label}
                </MuiTypography>
              </MuiPopover>

            </MuiGrid>
            :
            <MuiGrid elevation={3} style={{ zIndex: 100, position: 'relative', width: '97%', cursor: 'pointer', borderRadius: '3px',
             background: this.props.blocket.style, height: this.props.cellHeight * this.props.blocket.totalBlocks - 1 + 'px' }} 
             onClick={() => this.props.onEditOfPeriod(this.props.blocket.period, this.props.index, this.props.day)}>
              <MuiTypography classes="dummy" variant="caption"> {this.props.blocket.label}</MuiTypography>
            </MuiGrid>

        }
      </div>

    )
  }
}


export default muiWithStyles(useStyles)(EventComponent);
